import React from "react";
import { trimAddress } from '../hooks/constant';
import { useWeb3Modal } from '@web3modal/react';
import { useAccount } from "wagmi";


export const Connect = function () {
    const { open } = useWeb3Modal()
    const { address } = useAccount();

    return (
        <React.Fragment>
            {address ? (
                <button type="button" className="btn btn-warning m-3 text-white" onClick={() => open({ view: "Networks" })}>{trimAddress(address)}
                </button>
            ) : (
                <button type="button" className="btn btn-warning m-3 text-white" onClick={() => open()}>
                    Connect Wallet
                </button>
            )}

        </React.Fragment >
    );
};

export default Connect;